<template>
  <div class="breadcrumbs-style">
    <p v-for="(item,index) in breadcrumbs" :key="item.id">
      <span @click="selectDepart(item.data, index)">{{item.data.name}}<span v-if="index < breadcrumbs.length - 1" style="margin-right: 8px;">/</span></span>

    </p>
  </div>
</template>
<script>
import bus from '@/bus'
export default {
  props: {
    breadcrumbs: [Array]
  },
  data() {
    return {

    }
  },
  methods: {
    selectDepart(item, index) {
      if(index === this.breadcrumbs.length - 1) return
      bus.$emit('selectDepart', item)
    }
  }
}
</script>
<style lang="scss">
.breadcrumbs-style {
  font-size: 14px;
  display: flex;
  align-items: center;
  p {
    color: rgba(32, 32, 32, 0.6);
    i {
      font-size: 14px;
    }
    span {
      cursor: pointer;
      &:hover {
        color: initial;
      }
    }
  }
  p:last-child {
    span {
      cursor: auto;
      color: initial;
    }
  }
  i {
    margin: 0 8px;
  }
}
</style>
